module.exports = __webpack_public_path__ + "img/Estacao.6830ee3d.svg";